import React from 'react';
import styled from 'styled-components';
import Skeleton, {SkeletonProps} from '@material-ui/lab/Skeleton';
import {ParagraphSkeleton, ParagraphSkeletonProps} from '.';

const Radio = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export interface RadioItemSkeleton extends SkeletonProps {
    ParagraphSkeletonProps?: Partial<ParagraphSkeletonProps>;
}

const RadioItemSkeleton: React.FC<RadioItemSkeleton> = ({ParagraphSkeletonProps, ...props}) => (
    <Radio>
        <Skeleton variant="circle" width={25} height={24} {...props} />
        <ParagraphSkeleton
            type="radio"
            style={{margin: '10px 15px', width: '100%'}}
            {...ParagraphSkeletonProps}
        />
    </Radio>
);

export default RadioItemSkeleton;
